import { z } from 'zod'
import { PlatformType } from '@/types/schema/report-schema'

export const platformTypeSchema = z.nativeEnum(PlatformType)
